export default function (obj, path, fallbackValue) {
  const keys = path
    .replace(/\[([^\[\]]*)\]/g, '.$1.') // eslint-disable-line no-useless-escape
    .split('.')
    .filter(t => t !== '')

  return keys.reduce((xs, x) => xs?.[x] ?? fallbackValue ?? null, obj)
}
